import moment from 'moment';

document.addEventListener('DOMContentLoaded', function() {
  document.addEventListener('click', function(e) {
    if (!e.target || !e.target.matches('.deck_search_card_filter-remove')) return;
    var row = e.target.closest('.row');
    if (row) row.remove();
  });

  var newFilterBtn = document.getElementById("deck_search_card_filter-new");
  if (newFilterBtn) {
    newFilterBtn.addEventListener('click', function(e) {
      var input = document.getElementById('deck_search_card_filter-counter');
      var new_index = input ? input.value : '0';
      if (input) input.value = parseInt(input.value, 10) + 1;

      var template = document.getElementById("deck_search_card_filter-template");
      if (!template) return;
      var fragment = template.children[0].cloneNode(true);

      fragment.querySelectorAll(':is(input, select, textarea, button)').forEach(function(field) {
        if (field.hasAttribute('name')) {
          field.setAttribute('name', field.getAttribute('name').replace(/\[[0-9]+\]/, '[' + new_index + ']'));
        }
        if (field.hasAttribute('id')) {
          field.setAttribute('id', field.getAttribute('id').replace(/_[0-9]+_/, '_' + new_index + '_'));
        }
      });

      fragment.querySelectorAll('label').forEach(function(label) {
        if (label.hasAttribute('for')) {
          label.setAttribute('for', label.getAttribute('for').replace(/_[0-9]+_/, '_' + new_index + '_'));
        }
      });

      var container = document.getElementById("deck_search_card_filter-container");
      if (container) container.appendChild(fragment);
      bindAutoCompleteCard();
    });
  }
});
